/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function Tipografia(props) {
  const { titol, ...altresProps } = props;

  return <Typography {...altresProps}>{titol}</Typography>;
}

Tipografia.propTypes = {
  titol: PropTypes.string,
};
